import React from "react";
import * as P from "./style";
import DefaultUserImg from "../../Assets/Images/user-profile.png";
import { useNavigate } from "react-router-dom";
import { FeedPosts } from "../../Config/interface.config";
import PostAction from "./PostAction";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import { getImageUrl } from "../../Utils/helpers";

interface Props {
  post?: FeedPosts;
  userImage?: string;
}

const PostHeader: React.FC<Props> = ({ post, userImage }: Props) => {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.user);

  return (
    <P.Header className="cursor-pointer">
      <div
        className="flex cursor-pointer gap-3"
        onClick={() => navigate(`/profile/${post?.creator.username}`)}
      >
        <P.UserImage
          src={getImageUrl(userImage || post?.creator?.image?.fileURL || "") || DefaultUserImg}
          alt="user"
          loading="eager"
          decoding="async"
          onError={(event) => {
            if (!event.currentTarget.dataset.fallbackApplied) {
              event.currentTarget.dataset.fallbackApplied = "true";
              event.currentTarget.src = DefaultUserImg;
            }
          }}
        />
        <div>
          <P.UserTitle>{post?.creator?.fullname}</P.UserTitle>
          <P.UserName to={`/profile/${post?.creator?.username}`}>
            @{post?.creator?.username ?? ""}
          </P.UserName>
        </div>
      </div>

      <div>
        {user.id === (post?.creator?.id ?? post?.creator?._id) && (
          <PostAction post={post} />
        )}
      </div>
    </P.Header>
  );
};

export default PostHeader;
